import { MenuInfo } from "data";
import { Navigate, Route, Routes } from "react-router-dom";
import { MonitoringLayout } from "layout/monitoring";
import { Error404 } from "pages";
import DashboardMoniteringSub from "pages/monitoring/dashboard-sub";
import MonitoringReportDataroomRoutes from "./report-dataroom/MonitoringReportDataroomRoutes";
import MonitoringSettingRoutes from "./setting/MonitoringSettingRoutes";
import AuthorityRoute from "components/route/AuthorityRoute";
import { ROLE } from "data/data";
import PageTest from "pages/pageTest";

export default function MonitoringRoutes() {
    const monitoring = MenuInfo.CMMS;
    const report_dataroom = MenuInfo.CMMS_REPORT_DATAROOM;  // 보고서
    const setting = MenuInfo.CMMS_MANAGEMENT;   // 관리리
    return (
        <Routes>
            <Route path="/*" element={ <MonitoringLayout/> }>
                <Route path="/*" element={ <Navigate to={monitoring.children[0].path}/> }/>
                {
                    monitoring.children.map(child => {
                        return (
                            <Route key={child.id} path={child.path + (child.isRoutes ? '/*' : '')} element={ child.element }/>
                        );
                    }) 
                }

                <Route path={report_dataroom.path + '/*'} element={ <MonitoringReportDataroomRoutes/> } />
                <Route element={<AuthorityRoute pageRole={[ROLE.SA.code, ROLE.WA.code]} />}> 
                    <Route path={setting.path + '/*'} element={ <MonitoringSettingRoutes/> } />
                </Route>

                <Route path="dashboard/sub" element={ <DashboardMoniteringSub/> }/>
                <Route path="pageTest" element={ <PageTest /> }/>

                <Route path="*" element={ <Error404/> }/>
            </Route>
            
        </Routes>
    );
}